import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Brand } from "@/components/Brand";
import { useDisclosure } from "@/components/FundingDisclosure";
import { LangToggle } from "@/pages/Legal";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function DisclosureAgree({ checked, onChange, id = "signup" }) {
  const t = useDisclosure();
  const a = "text-emerald-700 font-semibold hover:underline";
  return (
    <label className="flex gap-2.5 items-start text-sm text-slate-600 cursor-pointer" data-testid={`disclosure-agree-${id}`} data-no-translate>
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid={`disclosure-agree-checkbox-${id}`} />
      <span>{t.agree[0]} <Link to="/terms" target="_blank" className={a}>{t.terms}</Link> {t.agree[1]} <Link to="/privacy" target="_blank" className={a}>{t.privacy}</Link>.</span>
    </label>
  );
}

export function DisclosureGate() {
  const { user, setUser, logout } = useAuth();
  const t = useDisclosure();
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-disclosure", null, { headers: { "X-UI-Lang": localStorage.getItem("gv_tour_lang") || "en" } });
      setUser(data);
    } catch (e) {
      toast.error(formatErr(e));
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6" data-testid="disclosure-gate" data-no-translate>
      <div className="w-full max-w-lg bg-white border border-slate-200 rounded-lg p-8 fade-up">
        <div className="flex justify-between items-center"><Brand /><LangToggle /></div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 mt-8">{t.gateTitle}</h1>
        <p className="text-sm text-slate-500 mt-1" data-testid="disclosure-gate-sub">{user?.disclosure_accepted_at ? t.gateUpdated : t.gateSub}</p>
        <div className="mt-5 bg-slate-50 border-l-4 border-l-emerald-500 rounded p-4 text-sm leading-relaxed text-slate-700" data-testid="disclosure-gate-text">
          <b>{t.label}:</b> {t.text}
        </div>
        <div className="mt-5"><DisclosureAgree checked={ok} onChange={setOk} id="gate" /></div>
        <div className="mt-6 flex gap-3">
          <Button onClick={accept} disabled={!ok || busy} className="flex-1 bg-emerald-600 hover:bg-emerald-700" data-testid="disclosure-gate-continue">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{t.cont}</Button>
          <Button variant="outline" onClick={logout} data-testid="disclosure-gate-logout">{t.signOut}</Button>
        </div>
      </div>
    </div>
  );
}
